class CompanyUtils {
    hasNotes(company) {
        let notes;

        if (company.hasOverride) {
            notes = company.overrideNotes;
        }
        else if(company.description) {
            notes = company.description;
        }

        return !!notes;
    }

    getAbbreviatedNotes(company) {
        const fullNotes = company.hasOverride ? company.overrideNotes : company.description;
        const abbrev = fullNotes.substr(0, 50);

        if (abbrev.length < fullNotes.length) {
            return `${abbrev}...`;
        }

        return abbrev;
    }

    fillNotes(srcCompany, dstCompany) {
        dstCompany.hasOverride = srcCompany.hasOverride;

        if (srcCompany.hasOverride) {
            dstCompany.r2Notes = srcCompany.origNotes;
            dstCompany.overrideNotes = srcCompany.overrideNotes;
            dstCompany.origNotes = srcCompany.origNotes;
        }
    }
}

export { CompanyUtils };
